const Shimmer = () => {
    return (
    <div className="shimmer-container ">
        <div className="shimmer-card"></div>
        <div className="shimmer-card"></div>
        <div className="shimmer-card"></div>   
        <div className="shimmer-card"></div>   
        <div className="shimmer-card"></div>   
        <div className="shimmer-card"></div>   
        <div className="shimmer-card"></div>   
        <div className="shimmer-card"></div>   
        <div className="shimmer-card"></div>   
        <div className="shimmer-card"></div>   
        <div className="shimmer-card"></div>   
        <div className="shimmer-card"></div>   
        <div className="shimmer-card"></div>   
    </div>
    );
};

export default Shimmer;